import React, { useContext, useEffect, useState } from 'react';
import { UseContext } from '../../Context/Context';
import './Income.css'


const Incomes = () => {
    const {user} = useContext(UseContext)
    const [income, setincome] = useState([])
    const [balance, setbalance] = useState(0)
  

  
     

      //delete
    //   const deleteItem=(id)=>{
    //     const confirmDelete = window.confirm(`Are you sure ${id.names}`)  
    //     if(confirmDelete){
    //       fetch(`https://tracker-server-lake.vercel.app/incomes/${id._id}`,{
    //           method: 'DELETE',           
    //       })
    //       .then(res=>res.json())
    //       .then(d=>{
    //           if(d.deletedCount > 0){         
    //               const remain = income.filter(v=> v._id !== id._id)
    //               setincome(remain)             
    //           }          
    //       })
    //     }              
    //   }
    return (
        <div>
            <h2 className='text-center py-6 text-2xl'>Total Income  $<span className='text-green-500 font-medium'>{balance}</span></h2>
           <div className="list">
            <form  className='form'>
                <input type="text" name='names' placeholder='Incomes Description' required />
                <input type="text" name='price' placeholder='Price' required />
                <input type="date" name='date' required />
                <button className='btn btn-sm mt-2 rounded-none btn-warning'>Add</button>
            </form>
            <div className="overflow-x-auto mt-6">
      <table className="table w-full ">
       
         <tbody className=''>
           
         </tbody>
      </table>
    </div>
         
           
            </div>
        </div>
    );
};

export default Incomes;